import { Controller } from "@hotwired/stimulus"

// Segmented control for the storefront: shows one product panel at a time
// (self-drive vs with-driver). With no JS, both panels render visibly.
export default class extends Controller {
  static targets = ["panel", "button"]
  static values = { default: { type: String, default: "self_drive" } }

  connect() {
    this.show(this.defaultValue)
  }

  select(event) {
    this.show(event.currentTarget.dataset.storefrontToggleKeyParam)
  }

  show(key) {
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.key !== key))
    this.buttonTargets.forEach((b) => {
      const on = b.dataset.storefrontToggleKeyParam === key
      b.classList.toggle("bg-white", on)
      b.classList.toggle("text-brand", on)
      b.classList.toggle("shadow-sm", on)
      b.classList.toggle("text-muted", !on)
    })
  }
}
